"use client";

import React from "react";

//Styles
import * as S from "./styled";
import Image from "../image";
import { useTheme } from "next-themes";

//Image
import LogoNight from "@/assets/images/logoSimple.png";
import LogoDay from "@/assets/images/logoSimple.png";
//import LogoNight from '@/assets/images/simpleLogo.png';
//import LogoDay from '@/assets/images/simpleLogoDay.png';
import Spinner from "../spinner/loading";

const LoadingPage = () => {
  const { theme } = useTheme();

  const Logo = theme === "dark" ? LogoNight : LogoDay;

  return (
    <S.BoxLoadingPage>
      <S.ImageComponent src={Logo} />
    </S.BoxLoadingPage>
  );
};

export default LoadingPage;
